import React from 'react';

import { Container, Typography } from '@material-ui/core';
import { isWidthUp } from '@material-ui/core/withWidth';
import Swiper from 'react-id-swiper';

import { BREAKPOINTS_VALUES, useWidth } from '../../theme';
import { Background } from '../../types';
import { splitIntoChunks } from '../../utils/helpers';
import Flipper from '../Flipper/Flipper';
import TeamMember from '../TeamMember/TeamMember';
import useStyles from './styles';

const swiperSetting = {
  slidesPerView: 2,
  spaceBetween: 20,
  pagination: {
    el: '.swiper-pagination',
    clickable: true,
  },
  containerClass: 'swiperWrapper',
  breakpoints: {
    [BREAKPOINTS_VALUES.sm]: {
      slidesPerView: 3,
    },
  },
};

const MeetTheTeam = ({ data }) => {
  const isDark = data?.background === Background.Dark;
  const classes = useStyles(isDark)();

  const width = useWidth();
  const isMobile = !isWidthUp('md', width);

  return (
    <div className={classes.wrapper}>
      <Container>
        <Typography variant={'h2'} className={classes.title}>
          {data?.heading}
        </Typography>
        {!isMobile ? (
          <div className={classes.cardsWrapper}>
            {data?.members?.map((member) => (
              <Flipper key={member.id} wrapperClass={classes.card}>
                <TeamMember
                  title={member.name}
                  jobTitle={member.employee_job_title}
                  imageUrl={member.avatar}
                  isDark={!isDark}
                  link={member.linkedin_url}
                  linkTitle="Linkedin"
                />
                <TeamMember
                  title={member.name}
                  jobTitle={member.employee_job_title}
                  imageUrl={member.secondary_image}
                  isDark={!isDark}
                  link={member.linkedin_url}
                  linkTitle="Linkedin"
                />
              </Flipper>
            ))}
          </div>
        ) : (
          <Swiper {...swiperSetting}>
            {splitIntoChunks(data?.members || [], 2).map((chunk, index) => (
              <div key={index}>
                {chunk.map((member) => (
                  <Flipper key={member.id} wrapperClass={classes.card}>
                    <TeamMember
                      title={member.name}
                      jobTitle={member.employee_job_title}
                      imageUrl={member.avatar}
                      isDark={!isDark}
                      link={member.linkedin_url}
                      linkTitle="Linkedin"
                    />
                    <TeamMember
                      title={member.name}
                      jobTitle={member.employee_job_title}
                      imageUrl={member.secondary_image}
                      isDark={!isDark}
                      link={member.linkedin_url}
                      linkTitle="Linkedin"
                    />
                  </Flipper>
                ))}
              </div>
            ))}
          </Swiper>
        )}
      </Container>
    </div>
  );
};

export default MeetTheTeam;
